<template>
  <div>
    <ex-card disable-offsets>
      <template slot="header">
        <v-dialog v-model="linkDialog" max-width="1000">
          <Link
            :clients="link.clients"
            :product_id="link.product_id"
            :isLoadedProduct="link.isMyProduct"
            @exit_link="linkDialog = false"
            @success_linking="after_link"
          />
        </v-dialog>
        <v-dialog v-model="url_dialog.show" max-width="1200">
          <v-card>
            <v-card-title class="display-1">
              <span class="red--text">URL : </span>
              {{ ` ${url_dialog.text}` }}
            </v-card-title>
            <v-card-actions class="d-flex flex-row justify-space-around">
              <v-btn
                @click="delete_url"
                color="secondary"
                class="red--text"
                :disabled="!can_reset "
              >delete url
              <v-icon>delete</v-icon>
              </v-btn>
              <v-btn
                color="secondary"
                @click="url_dialog.show = false"
              >close
              <v-icon>close</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div class="inner">
          <h2 class="display-1 red--text text--darken-2">Resolve Conflict</h2>
          <div>
            <v-btn
              text
              :ripple="false"
              class="my-0 mx-1 ex-btn ex-opacity-btn"
              @click="cancelResolve"
            >
              Exit
            </v-btn>
            <v-btn
              text
              :ripple="false"
              class="my-0 mx-1 ex-btn ex-opacity-btn"
              @click="initializing"
              :disabled="!!all_bins_url_ids.length"
            >
              Reset
            </v-btn>
            <v-btn
              text
              :ripple="false"
              class="my-0 mx-1 ex-btn ex-opacity-btn"
              @click="submit"
              :loading="loading && conflict_loading"
            >
              <!-- :disabled="!unique_urls_per_domain" -->
              <!-- :disabled="!can_reset" -->
              Save
            </v-btn>
          </div>
        </div>
        <div class="d-flex flex-row justify-center my-2">
          <div class="d-flex flex-column justify-space-around mx-3">
            <v-btn
              text
              color="warning lighten-1"
              :ripple="false"
              class="my-1 mx-2 ex-btn ex-opacity-btn"
              @click="move_all_left"
              :disabled="!can_reset"
            >
              move all left
              <v-icon class="ms-1">keyboard_double_arrow_left</v-icon>
            </v-btn>
            <v-btn
                text
                color="primary lighten-1"
                :ripple="false"
                class="my-1 mx-2 ex-btn ex-opacity-btn"
                @click="link_my_or_pending_product"
              >
                <v-icon>link</v-icon>
                <span class="mx-2">Link</span>
                <v-icon>arrow_forward</v-icon>
            </v-btn>
          </div>
          <div class="d-flex flex-column mx-3">
            <h2 class="subtitle">
              Left Product: {{ selected_product.product_brand.name }} -
              <span class="red--text text--lighten-3">
                {{ selected_product.product_name }}
              </span>
            </h2>
            <h2 class="subtitle">
              Product_id: <span class="red--text text--lighten-3">{{ selected_product.product_id }}</span>
            </h2>
            <h2 class="subtitle">
              Created at: <span class="red--text text--lighten-3">{{ selected_product.created_at }}</span>
            </h2>
            <h2 class="subtitle">Clients:
              <span class="red--text text--lighten-3">
                {{ !!clients.length ? clients.join(" , ") : 'No clients found' }}
              </span>
            </h2>
            <h2 class="subtitle">EAN:
              <span class="red--text text--lighten-3">
                {{ selected_product.ean }}
              </span>
            </h2>
            <h2 class="subtitle">SKU:
              <span class="red--text text--lighten-3">
                {{ selected_product.sku }}
              </span>
            </h2>
          </div>
          <v-divider vertical class="mx-2"></v-divider>
          <div class="d-flex flex-column mx-3">
            <h2 class="subtitle">
              Right - Conflict Product:
              <span class="red--text text--lighten-3">
                {{ other_or_conflict_product_info.product_brand.name }} -
                {{ other_or_conflict_product_info.product_name }}
              </span>
            </h2>
            <h2 class="subtitle">
              Product_id:
              <span class="red--text text--lighten-3">
                {{ other_or_conflict_product_info.product_id }}
              </span>
            </h2>
            <h2 class="subtitle">
              Created at:
              <span class="red--text text--lighten-3">
                {{ other_or_conflict_product_info.created_at.date }}
              </span>
            </h2>
            <h2 class="subtitle">Clients:
              <span class="red--text text--lighten-3">
                {{ !!other_or_conflict_clients.length ? other_or_conflict_clients.join(" , ") : 'No clients found' }}
              </span>
            </h2>
            <h2 class="subtitle">EAN:
              <span class="red--text text--lighten-3">
                {{ other_or_conflict_product_info.ean }}
              </span>
            </h2>
            <h2 class="subtitle">SKU:
              <span class="red--text text--lighten-3">
                {{ other_or_conflict_product_info.sku }}
              </span>
            </h2>
          </div>
          <div class="d-flex flex-column justify-space-around">
            <v-btn
              text
              color="warning lighten-1"
              :ripple="false"
              class="my-1 mx-2 ex-btn ex-opacity-btn"
              @click="move_all_right"
              :disabled="!can_reset"
            >
              <v-icon class="me-1">keyboard_double_arrow_right</v-icon>
              move all right
            </v-btn>
            <v-btn
                text
                color="primary lighten-1"
                :ripple="false"
                class="my-1 mx-2 ex-btn ex-opacity-btn"
                @click="link_other_or_conflict_product"
              >
                <v-icon>arrow_back</v-icon>
                <span class="mx-2">Link</span>
                <v-icon>link</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <v-divider></v-divider>
      <div
        class="domain_section my-2"
        v-for="(dom, dom_idx) in all_domains"
        :key="dom.domain_id"
      >
        <!-- <div
        class="domain_section my-2"
        v-for="(url, url_index) in conflict_items"
        :key="url_index"
      > -->
        <div class="d-inline-block line-url">
          <div class="d-flex justify-space-between mx-4">
            <span>{{ ++dom_idx }}.</span>
            <span class="font-weight-bold">{{ dom.domain_name }}</span>
          </div>
        </div>
        <!-- <div class="d-inline-block line-url">
          <span class="d-flex justify-center">{{ url.domain_name }}</span>
        </div> -->
        <div class="d-inline-block line-dec">
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(url, url_index) in conflict_items.filter(
                (x) => x.domain_id == dom.domain_id
              )"
              :key="url_index"
            >
              <!-- <v-expansion-panel> -->
              <div class="d-flex justify-space-around align-center panel-h">
                <span class="left-span">
                  <div class="row">
                    <div
                      class="col-11 text-truncate url_text"
                      @click="openUrl(try_decode_uri(pending_items.find((x) => x.url_id == url.url_id).url), url.url_id)">
                      <span v-if="pending_items.find((x) => x.url_id == url.url_id)">
                        {{try_decode_uri(pending_items.find((x) => x.url_id == url.url_id).url)}}
                      </span>
                      <span v-else></span>
                    </div>
                    <v-btn
                      small
                      fab
                      class="red--text mt-1"
                      v-if="pending_items.find((x) => x.url_id === url.url_id) && !!pending_items.find((x) => x.url_id === url.url_id).url &&!!url.url"
                      @click="deleteItem(true,pending_items.findIndex((x) => x.url_id == url.url_id))"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <!-- <v-btn v-else-if="!url.url" class="mt-1" @click.stop fab small>cpl</v-btn> -->
                    <v-btn
                      @click.native.stop="copyLink"
                      fab
                      dark
                      x-small
                      v-else-if="!url.url"
                      title="Copy the link"
                      class="mt-1"
                      color="secondary"
                    >
                      <v-icon>content_copy</v-icon>
                    </v-btn>
                  </div>
                </span>
                <v-btn
                  v-if="!(pending_items.find((x) => x.url_id == url.url_id) && !!pending_items.find((x) => x.url_id == url.url_id).url && !!url.url)
                        && !pending_items.find((x) => x.url_id == url.url_id)"
                  @click="swapUrls(conflict_items.findIndex((x) => x.url_id == url.url_id))"
                >
                  <v-icon>west</v-icon>
                </v-btn>
                <v-btn
                  v-if="!(pending_items.find((x) => x.url_id == url.url_id) && !!pending_items.find((x) => x.url_id == url.url_id).url
                    && !!url.url ) && pending_items.find((x) => x.url_id == url.url_id)"
                    @click="swapUrls(conflict_items.findIndex((x) => x.url_id == url.url_id))"
                >
                  <v-icon>east</v-icon>
                </v-btn>
                <span class="right-span">
                  <div class="row">
                    <v-btn
                      small
                      fab
                      class="red--text mt-1"
                      v-if="pending_items.find((x) => x.url_id == url.url_id) && !!pending_items.find((x) => x.url_id == url.url_id).url && !!url.url"
                      @click="deleteItem(false, conflict_items.findIndex((x) => x.url_id == url.url_id))"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <!-- <v-btn v-else-if="!!url.url" class="mt-1" @click.stop fab small>cpr</v-btn> -->
                    <v-btn
                      @click.native.stop="copyLink"
                      fab
                      dark
                      x-small
                      v-else-if="!!url.url"
                      title="Copy the link"
                      class="mt-1"
                      color="secondary"
                    >
                      <v-icon>content_copy</v-icon>
                    </v-btn>
                    <div
                      class="col-11 text-truncate url_text"
                      @click="openUrl(try_decode_uri(url.url), url.url_id)"
                    >
                      {{ try_decode_uri(url.url) }}
                      <!-- {{ url.product_id }} -->
                    </div>
                  </div>
                </span>
              </div>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <v-divider class="my-3"></v-divider>
      </div>
    </ex-card>
  </div>
</template>

<script>
/* eslint-disable */
import * as help from "@/helpers/functions";
import Link from "./N_Link.vue";
import { productionBus } from "@/helpers/buses";

export default {
  name: "N_ResolveConflictTable",
  components: { Link },
  props: ["id", "conflict_index"],
  data() {
    return {
      conflict_loading: false,
      current_product_id: this.$route.params.id,
      linkClients: [], // link v-model
      // clients: [], // array with names of clients
      merge_container: [],
      conflict_items: [],
      pending_items: [],
      track_ids_for_delete: [],
      all_domains: [],
      all_bins_url_ids: [],
      can_reset: false,
      url_dialog: {
        show: false,
        text: "",
        url_id: 0,
      },
      linkDialog: false,
      link: {
        clients: [],
        product_id: 0,
        isMyProduct: true,
      },
      linkSwitch: false,
      other_or_conflict_product_info: (this.$store.state.productionModule.conflict_temporary_data)
        ? this.$store.state.productionModule.conflict_temporary_data
          .merge_container[0].product_conflict.product_info
        : [],
    };
  },
  computed: {
    clients_list() {
      return this.$store.state.productionModule.clients_list;
    },
    selected_product() {
      // returns the object of product with all the specs
      return this.$store.state.productionModule.loaded_products.find(
        (x) =>
          x.product_id ===
          this.$store.state.productionModule.selected_product.id
      );
    },
    clients: {
      get() {
        return this.$store.state.productionModule.selected_product.specs.product_clients.map(c => c.client_name);
      },
      set(value) {
        this.$store.commit('productionModule/SET_PENDING_PRODUCT_CLIENTS', value);
      }
    },
    other_or_conflict_clients: {
      get() {
        return this.$store.state.productionModule.conflict_temporary_data.clients_conflict;
      },
      set(value) {
        this.$store.commit('productionModule/SET_CONFLICT_PRODUCT_CLIENTS', value);
        // this.$store.state.productionModule.conflict_temporary_data.clients_conflict = value;
      }
    },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set( value ) {
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", {value, key: 'loading'})
      }
    },
       unique_urls_per_domain () {
      const pending = [];
      this.pending_items.forEach(url => {
        if(!!url.url){
          const found = pending.find(p => p.domain_id === url.domain_id)
          if(found === undefined) {
            pending.push({domain_id: url.domain_id, count: 1})
          } else {
            found.count ++;
          }
        }
      })
      const can_save_pending = pending.every(domain => domain.count === 1)
      if(!can_save_pending) return false;
      const conflicts = [];
      this.conflict_items.forEach(url => {
        if(!!url.url){ // url !== ""
          const found = conflicts.find(p => p.domain_id === url.domain_id)
          if(found === undefined) {
            conflicts.push({domain_id: url.domain_id, count: 1})
          } else {
            found.count ++;
          }
        }
      })
      const can_save_conflict = conflicts.every(domain => domain.count === 1)
      return can_save_pending && can_save_conflict
    },
  },
  methods: {

    initializing() {
      // this.create_linked_clients();
      this.creation_merge_container();
      this.creation_conflict_items();
      this.creation_pending_items();
      console.log("before merge conflict items", this.conflict_items);
      console.log("before merge pending items", this.pending_items);
      this.merge_pendings_to_conflict_items();
      this.conflict_items.sort(this.sortDomains);
      this.create_all_domains_array();
      // this.all_domains.sort(this.sortDomains);
      this.create_bins();
    },
    deleteItem(isPendingItem, index) {
      console.log("is item pending ", isPendingItem);
      console.log("item index ", index);

      if (isPendingItem) {
        const conflict_has_sellers = !!this.conflict_items.find(x => this.pending_items[index].url_id === x.url_id).sellers.length;
        if(!conflict_has_sellers){ // * 1
          this.conflict_items.find(x => this.pending_items[index].url_id === x.url_id).sellers = JSON.parse(JSON.stringify(this.pending_items[index].sellers));
        }
        this.all_bins_url_ids = this.all_bins_url_ids.filter(
          (x) => x != this.pending_items[index].url_id
        );
        console.log(
          "delete - this.pending_items[index].url_id",
          this.pending_items[index].url_id
        );
        this.pending_items.splice(index, 1);
      } else {
        const pending_has_sellers = !!this.pending_items.find(x => this.conflict_items[index].url_id === x.url_id).sellers.length;
        if(!pending_has_sellers){   // * 1
          this.pending_items.find(x => this.conflict_items[index].url_id === x.url_id).sellers = JSON.parse(JSON.stringify(this.conflict_items[index].sellers));
        }
        this.all_bins_url_ids = this.all_bins_url_ids.filter(
          (x) => x != this.conflict_items[index].url_id
        );
        console.log(
          "delete - this.conflict_items[index].url_id",
          this.conflict_items[index].url_id
        );
        this.conflict_items[index].url = "";
      }
      this.can_reset = true;
      // *1 ) urls tou skroutz pou erxontai apo to validation den fernoun sellers kai den yparxei to track_id na ginei metafora
      //      gi auto pairnv tous sellers apo to conflict item
    },
    delete_url() {
      const delete_track_ids = JSON.parse(JSON.stringify(this.conflict_items.find(x => x.url_id === this.url_dialog.url_id).sellers.map(s => s.track_id )));
      console.log('delete_track_ids', delete_track_ids)
      this.pending_items = this.pending_items.filter(x => x.url_id !== this.url_dialog.url_id)
      this.conflict_items = this.conflict_items.filter(x => x.url_id !== this.url_dialog.url_id)
      this.track_ids_for_delete.push(...delete_track_ids);
      this.url_dialog.show = false;
    },
    swapUrls(index) {
      if (this.conflict_items[index].url == "") {
        // go right
        const pending_index = this.pending_items.findIndex(
          (x) => x.url_id == this.conflict_items[index].url_id
        );
        // [this.pending_items[pending_index], this.merge_container[index]] = [this.merge_container[index], this.pending_items[pending_index]];
        this.conflict_items[index].url = this.pending_items[pending_index].url;
        this.conflict_items[index].product_id = parseInt(this.other_or_conflict_product_info.product_id)
        this.pending_items.splice(pending_index, 1);
        // other_or_conflict_product_info.product_id
      } else {
        // go left
        this.conflict_items[index].product_id = parseInt(this.selected_product.product_id);
        this.pending_items.push(
          JSON.parse(JSON.stringify(this.conflict_items[index]))
        );
        this.conflict_items[index].url = "";
      }
      this.can_reset = true;
    },
    move_all_left() {
      this.conflict_items.forEach((item, index) => {
        if(item.url !== ''){
          this.swapUrls(index);
        }
      })
    },
    move_all_right() {
      this.conflict_items.forEach((item, index) => {
        if(item.url == ''){
          this.swapUrls(index);
        }
      })
    },
    openUrl(text, id) {
      this.url_dialog.text = text;
      this.url_dialog.url_id = id;
      this.url_dialog.show = true;
    },
    try_decode_uri(text) {
      try {
        const url = decodeURI(text);
        return url;
      } catch (error) {
        console.log('error decode_uri', error);
        return text;
      }
    },
    reset_linkClients() {
      this.linkClients = [];
    },
    sortDomains(a, b) {
      // console.log(a.domain_name,'-',b.domain_name)
      let aName = a.domain_name
        .replace("https://", "")
        .replace("http://", "")
        .replace("www.", "");
      let bName = b.domain_name
        .replace("https://", "")
        .replace("http://", "")
        .replace("www.", "");
      // console.log(aName, bName)
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    },
    creation_merge_container() {
      // console.log('pending test: production', this.merge_container_product)
      this.merge_container = JSON.parse(
        JSON.stringify(
          this.$store.state.productionModule.conflict_temporary_data
            .merge_container[0]
          // need fix the [0]
          // .find(
          //   product => product.product_conflict.product_info.product_id == this.selected_product.product_id.toString()
          // )
        )
      );
    },
    creation_conflict_items() {
      this.conflict_items = [];
      this.conflict_items = help.exractProductDomains(
        this.merge_container.product_conflict.product_domains
      );
      this.conflict_items.forEach(item => {
        item.product_id = parseInt(this.other_or_conflict_product_info.product_id);
      });
      console.log("extracted conflict items", this.conflict_items);
    },
    creation_pending_items() {
      this.pending_items = [];
      this.pending_items = help.exractProductDomains(
        this.merge_container.product_pending.product_domains
      );
      this.pending_items.forEach(item => {
        item.product_id = parseInt(this.selected_product.product_id);
      });
      console.log("extracted pending items", this.pending_items);
    },
    merge_pendings_to_conflict_items() {
      this.pending_items.forEach((item) => {
        if (
          this.conflict_items.find((c) => c.url_id == item.url_id) === undefined
        ) {
          let temp_item = JSON.parse(JSON.stringify(item));
          temp_item.url = "";
          temp_item.product_id = parseInt(this.other_or_conflict_product_info.product_id);
          this.conflict_items.push(temp_item);
          // (temp_item.url = ""),
          //   this.conflict_items.push(JSON.parse(JSON.stringify(temp_item)));
        }
      });
      // new valids has url_id <= 0
      // pendings has url_id > 0
      this.conflict_items.forEach((el) => {
        if (el.url_id < 0) {
          el.url = "";
        }
      });
    },
    create_all_domains_array() {
      // for create seperate domains on template
      // creates all_domains an [array] with objects: {domain_id, domain_name} with no duplicates
      const temp_conflict_domain_ids = this.conflict_items.map(
        (x) => x.domain_id
      );
      // console.log('temp_conflict_domain_ids',temp_conflict_domain_ids.sort())
      const temp_pending_domain_ids = this.pending_items.map(
        (x) => x.domain_id
      );
      // console.log('temp_pending_domain_ids',temp_pending_domain_ids.sort())
      const temporary_domains = [
        ...new Set(temp_pending_domain_ids.concat(temp_conflict_domain_ids)),
      ];
      // console.log('temporary_domains',temporary_domains)
      this.all_domains = this.all_domains.filter((x) => x == undefined);
      const domain_length = this.all_domains.length;
      for (let i = 0; i < domain_length; i++) {
        this.all_domains.pop();
      }
      const temp_conflict_pending = this.conflict_items.concat(
        this.pending_items
      );
      // console.log('temp_conflict_pending', temp_conflict_pending);
      temporary_domains.forEach((el) => {
        this.all_domains.push({
          domain_id: temp_conflict_pending.find((x) => x.domain_id == el)
            .domain_id,
          domain_name: temp_conflict_pending.find((x) => x.domain_id == el)
            .domain_name,
        });
      });
      console.log("finally all domains ", this.all_domains);
    },
    cancelResolve() {
      this.$store.commit("productionModule/SET_PRODUCTION_STATE", {
        key: "conflict_temporary_data",
        value: {},
      });
      this.$router.replace({ name: "product-table" });
    },
    submit() {
      // remove the {} objects with empty url ""
      // conflict_items with url_id < 0 make it url_id = 0 for server understanding
      // pending_items with url_id < 0 make it url_id = 0 for server understanding
      // recreate merge_container
      this.loading = true;
      this.conflict_loading = true;
      const new_conflict_items = JSON.parse(
        JSON.stringify(this.conflict_items.filter((x) => !!x.url))
      );
      const new_pending_items = JSON.parse(
        JSON.stringify(this.pending_items.filter((x) => !!x.url))
      );
      //try new_conflict_items = help.eliminate_negative_ids(new_conflict_items)
      new_conflict_items.forEach((con_item) => {
        if (con_item.url_id < 0) {
          con_item.url_id = 0;
        }
      });
      //try new_pending_items = help.eliminate_negative_ids(new_pending_items)
      new_pending_items.forEach((pen_item) => {
        if (pen_item.url_id < 0) {
          pen_item.url_id = 0;
        }
      });
      const merge_container = {};
      this.merge_container.product_pending.product_info = JSON.parse(JSON.stringify(this.selected_product));
      const product_conflict = {
        product_domains: help.compressToProductDomains(new_conflict_items),
        product_info: this.merge_container.product_conflict.product_info, // check it
      };
      const product_pending = {
        product_domains: help.compressToProductDomains(new_pending_items),
        product_info: this.merge_container.product_pending.product_info, // check it
      };
      console.log('conflict', product_conflict.product_domains)
      console.log('pending', product_pending.product_domains)
      const temp_obj_for_assign = JSON.parse(
        JSON.stringify({
          product_conflict,
          product_pending,
          deleted_track_ids: this.track_ids_for_delete,
        })
      );
      Object.assign(merge_container, temp_obj_for_assign);
      console.log("merge_container", merge_container);
      // return true;
      const submit_data = {
        task: "newConflictSave",
        payload: merge_container,
      };
      console.log("payload", submit_data);
      // return false;
      this.$store
        .dispatch("productionModule/general_api", submit_data)
        .then((res) => {
          console.log("newConflictSave");
          console.log("results", res);
          console.log("results.data", res.data);
          this.$store.commit(
            "productionModule/RESET_PRODUCT_CONFLICT",
            this.current_product_id
          );
          const pen_items = new_pending_items.length
          const for_load_id = (pen_items !== 0) ? this.selected_product.product_id : this.other_or_conflict_product_info.product_id ;
          productionBus.$emit('loadProduct', for_load_id ); // if all url went right , load the right product
          this.$router.push({ name: "product-table" });
        }).catch((err) => {
          console.log("conflictSave error", err);
        }).finally(() => {
          this.loading = false;
          this.conflict_loading = false;
        })
    },
    link_my_or_pending_product () {
      this.link = {
        clients : this.clients,
        product_id : parseInt(this.selected_product.product_id),
        isMyProduct : true,
      }
      this.linkDialog = true;
    },
    link_other_or_conflict_product() {
      this.link = {
        clients : this.other_or_conflict_clients,
        product_id : parseInt(this.other_or_conflict_product_info.product_id),
        isMyProduct : false,
      }
      this.linkDialog = true;
    },
    create_bins() {
      // all_bins_url_ids -> kadoi
      this.can_reset = false;
      this.all_bins_url_ids = [];
      this.conflict_items.forEach((item) => {
        // this.pending_items.find((p) => (p.url_id === item.url_id && p.product_id === item.product_id))
        // && !this.all_bins_url_ids.includes(item.url_id)
        // && this.all_bins_url_ids.push(item.url_id)
        this.pending_items.find((x) => x.url_id == item.url_id) &&
          !!this.pending_items.find((x) => x.url_id == item.url_id).url &&
          !!item.url &&
          this.all_bins_url_ids.push(item.url_id);
      });
      this.track_ids_for_delete = [];
    },
    after_link( { linkSwitch, clients } ) {
      console.log('after link', linkSwitch, clients)
      if(linkSwitch && this.link.isMyProduct){ // link && myproduct-pendingProduct
        const current_clients = this.clients_list.filter(c => this.clients.includes(c.text))
        console.log('link my product', current_clients);
        this.clients = current_clients.concat(clients);
      } else if(linkSwitch && !this.link.isMyProduct) { // link && other-conflict_product
        const commited_clients = this.other_or_conflict_clients.concat(clients.map(c => c.text));
        this.other_or_conflict_clients = commited_clients;
      } else if(!linkSwitch && this.link.isMyProduct) { //unlink && myProduct-pendingProduct
        const current_clients = this.clients_list.filter(c => this.clients.includes(c.text))
        this.clients = current_clients.filter(c => !clients.map(cl=>cl.text).includes(c.text));
      } else if(!linkSwitch && !this.link.isMyProduct) { //unlink && other-conflict_product
        const commited_clients = this.other_or_conflict_clients.filter(c => !clients.map(cl => cl.text).includes(c));
        this.other_or_conflict_clients = commited_clients;
      }
      this.linkDialog = false;
    },
    copyLink({ target }) {
      const link = target
        .closest(".row")
        .querySelector(".url_text").innerText;
      const tempElement = document.createElement("input");
      tempElement.value = link;
      document.getElementsByTagName("body")[0].append(tempElement);
      tempElement.select();
      document.execCommand("copy");
      tempElement.remove();
    },
  },
  mounted() {
    if (this.$store.state.productionModule.conflict_temporary_data) {
      this.initializing();
    }
  },
};
</script>

<style scoped>
@import "https://pro.fontawesome.com/releases/v5.10.0/css/all.css";
td {
  text-align: center;
}
.mred {
  color: red;
  text-align: center;
}
.mmouse {
  cursor: pointer;
}
tr {
  /* border: 2px solid red; */
  height: 4em;
  border-top: 1px solid red;
  position: relative;
}

.left-span {
  width: 45%;
}
.right-span {
  width: 45%;
}
.line-url {
  width: 20%;
}
.line-dec {
  width: 79%;
}
.panel-h {
  min-height: 50px;
}
.span-url {
  display: flex;
  justify-content: space-around;
}
</style>


// WEBPACK FOOTER //
// src/components/production/N_ResolveConflictTable.vue